export const closeUploadBoxAlertMessage = '关闭上传列表后，上传中的工程可在历史上传中查看。'
export const abortUploadAlertMessage = '确定要取消该上传吗？'
export const maximumValidateMessage = '文件过多，一次最多可以上传100个文件'
export const suffixValidateMessage = '不支持此类工程文件导入'
export const fileSizeValidateMessage = '单个文件不能超过500MB，请您选择小于500MB的文件上传'
export const capacityValidateMessage = '空间容量不足，请重试'
export const duplicateFileAlertMsg = '存在一个或多个文件重名，是否替换？'
export const inventoryAlertMsg = '导入清单是否需要把其组价方案一起导入？'
export const uploadResultUrl = 'upload_history/upload_result'
export const name = '工程文件'
export const uploadFailMessage = '文件上传失败，请稍后重试'
